import { forwardRef } from "react";
import { emojiFor } from "@/data/issues";

const LOGO = "/sbgwc-logo-white.png";

export function buildMessage(name, issues) {
  const parts = (issues || []).map((i) => i.toLowerCase());
  const list = parts.length > 1 ? `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}` : parts[0] || "my future";
  return `I can't vote yet, but ${list} ${parts.length === 1 || parts.length === 0 ? "is an issue" : "are issues"} that I care about. I'm asking you to vote for me, until I can.`;
}

const VoiceCard = forwardRef(function VoiceCard({ name, age, issues = [], custom, city, state }, ref) {
  const meta = [age ? `Age ${age}` : null, [city, state].filter(Boolean).join(", ") || null].filter(Boolean).join(" · ");
  return (
    <div className="voice-card" ref={ref} data-testid="voice-card">
      <div className="vc-top">
        <div>
          <div className="vc-name" data-testid="voice-card-name">{name || "A Southern Black girl"}</div>
          {meta ? <div className="vc-age" data-testid="voice-card-meta">{meta}</div> : null}
        </div>
        <img className="vc-logo" src={LOGO} alt="SBGWC" crossOrigin="anonymous" />
      </div>
      <div className="vc-tagline">can't vote yet — but this is my message</div>
      <div className="vc-message">{buildMessage(name, issues)}</div>
      {custom && custom.trim() ? (
        <div className="vc-own" data-testid="voice-card-own-words">
          <span className="vc-own-lbl">My personal message to you</span>
          <span className="vc-own-text">“{custom.trim()}”</span>
        </div>
      ) : null}
      <div className="vc-chips">
        {issues.map((i) => (
          <span className="vc-chip" key={i}><span className="vc-chip-emoji">{emojiFor(i)}</span><span>{i}</span></span>
        ))}
      </div>
      <div className="vc-divider" />
      <div className="vc-footer">
        <div className="vc-hashtag">#VoteForMeUntilICan</div>
        <span className="vc-toolbox">blackvotersmatterfund.org/vote</span>
      </div>
    </div>
  );
});

export default VoiceCard;
